module.exports = __webpack_public_path__ + "img/Feature.adc7961d.jpg";